import { ROLES } from './roles';

// #1746 — rota "casa" de cada papel DENTRO do SPA. `/` exige `dashboard.view`,
// que só admin/operator/viewer/report-viewer têm: mandar `platform` ou
// `monitor` para `/` os leva a /unauthorized sem caminho de volta.
//
// Mesmo mapa que o AuthContext aplica depois do login (monitor → /reader-logs,
// platform → /platform/unclaimed-devices). `operator` sai do SPA para
// `/ttsense/` no AuthContext — isso é redirect entre aplicações, não rota do
// React Router, então aqui ele fica com `/` como os demais.
export const ROLE_HOME_PATHS = Object.freeze({
  [ROLES.MONITOR]: '/reader-logs',
  [ROLES.PLATFORM]: '/platform/unclaimed-devices',
});

export const DEFAULT_HOME_PATH = '/';

export function getRoleHomePath(role) {
  return ROLE_HOME_PATHS[role] || DEFAULT_HOME_PATH;
}
